export enum StageImage {
    Aspiration = '../../../../assets/images/modals/aspiration.png',
    SelfMastery = '../../../../assets/images/modals/self-mastery.png',
    Competence = '../../../../assets/images/modals/competence.png',
    Environment = '../../../../assets/images/modals/environment.png',
    Opportunity = '../../../../assets/images/modals/opportunity.png',
    Delivery = '../../../../assets/images/modals/delivery.png',
    Wellness = '../../../../assets/images/modals/wellness.png'
}
